import * as React from 'react';
import { Skeleton as MatSkeleton, skeletonClasses, SkeletonProps, SxProps, Theme } from '@mui/material';

const styles: Record<string, SxProps<Theme>> = {
  skeletonLoaderRoot: {
    marginBottom: 0.5,
    [`&.${skeletonClasses['wave']}:after`]: {
      background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.12), transparent)'
    }
  }
};

const SkeletonLoader: React.FunctionComponent<SkeletonProps> = ({ animation = 'wave', height = 10, sx, ...rest }: SkeletonProps) => {
  const { skeletonLoaderRoot } = styles;
  return <MatSkeleton sx={[skeletonLoaderRoot, sx] as SxProps<Theme>} animation={animation} height={height} {...rest} />;
};

SkeletonLoader.displayName = 'SkeletonLoader';

export { SkeletonLoader };
